var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoInterattivoNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    "data-name": "Livello 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 811.58 252.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1e1e1c;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #16b9ed;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tracciato_2282",
    "data-name": "Tracciato 2282"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M708.74,203.37H102.84c-13.57,0-26.74-2.66-39.13-7.9-11.97-5.06-22.72-12.31-31.95-21.54-9.23-9.23-16.48-19.98-21.54-31.95-5.24-12.39-7.9-25.56-7.9-39.13s2.66-26.74,7.9-39.13c5.06-11.97,12.31-22.72,21.54-31.95,9.23-9.23,19.98-16.48,31.95-21.54,12.39-5.24,25.56-7.9,39.13-7.9h605.9c13.57,0,26.74,2.66,39.13,7.9,11.97,5.06,22.72,12.31,31.95,21.54,9.23,9.23,16.48,19.98,21.54,31.95,5.24,12.39,7.9,25.56,7.9,39.13s-2.66,26.74-7.9,39.13c-5.06,11.97-12.31,22.72-21.54,31.95-9.23,9.23-19.98,16.48-31.95,21.54-12.39,5.24-25.56,7.9-39.13,7.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.84,4.62c-13.26,0-26.12,2.6-38.23,7.72-11.69,4.95-22.2,12.03-31.22,21.05-9.02,9.02-16.1,19.53-21.05,31.22-5.12,12.11-7.72,24.97-7.72,38.23s2.6,26.12,7.72,38.23c4.95,11.69,12.03,22.2,21.05,31.22,9.02,9.02,19.53,16.1,31.22,21.05,12.11,5.12,24.97,7.72,38.23,7.72h605.9c13.26,0,26.12-2.6,38.23-7.72,11.69-4.95,22.2-12.03,31.22-21.05,9.02-9.02,16.1-19.53,21.05-31.22,5.12-12.11,7.72-24.97,7.72-38.23s-2.6-26.12-7.72-38.23c-4.95-11.69-12.03-22.2-21.05-31.22-9.02-9.02-19.53-16.1-31.22-21.05-12.11-5.12-24.97-7.72-38.23-7.72H102.84M102.84,0h605.9c56.8,0,102.84,46.04,102.84,102.84s-46.04,102.84-102.84,102.84H102.84C46.04,205.68,0,159.64,0,102.84S46.04,0,102.84,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.72,144.18l-28.37-71.63h19.2l18.77,54.44h.57l18.77-54.44h19.06l-28.66,71.63h-19.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.7,145.61c-11.66,0-21.2-3.48-28.65-10.46-7.46-6.97-11.18-15.91-11.18-26.79s3.72-19.82,11.18-26.79c7.45-6.97,16.99-10.46,28.65-10.46s21.06,3.49,28.51,10.46c7.45,6.97,11.17,15.91,11.17,26.79s-3.72,19.82-11.17,26.79c-7.45,6.97-16.95,10.46-28.51,10.46ZM177.16,124.2c4.06,4.15,9.23,6.23,15.54,6.23s11.5-2.08,15.62-6.23c4.1-4.15,6.16-9.43,6.16-15.83s-2.06-11.68-6.16-15.83c-4.11-4.15-9.31-6.23-15.62-6.23s-11.48,2.08-15.54,6.23c-4.07,4.15-6.09,9.43-6.09,15.83s2.02,11.68,6.09,15.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M246.56,144.18V41.03h17.91v103.15h-17.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.83,72.55l17.91-.15v71.63h-17.91v-14.18h-.28c-2.39,4.97-5.85,8.81-10.39,11.53-4.54,2.72-9.77,4.08-15.69,4.08-10.03,0-18.41-3.54-25.14-10.61-6.74-7.07-10.11-15.9-10.11-26.5s3.37-19.6,10.11-26.72c6.73-7.11,15.11-10.68,25.14-10.68,5.92,0,11.15,1.39,15.69,4.15,4.53,2.77,8,6.64,10.39,11.61h.28v-14.18ZM319.63,130.14v-.15c6.4,0,11.66-2.05,15.76-6.16,4.11-4.11,6.17-9.31,6.17-15.62s-2.06-11.5-6.17-15.62c-4.1-4.11-9.35-6.16-15.76-6.16s-11.66,2.05-15.76,6.16c-4.11,4.11-6.17,9.31-6.17,15.62s2.06,11.66,6.17,15.76c4.1,4.11,9.35,6.16,15.76,6.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M419.2,71.12h-.15c8.31,0,14.91,2.58,19.77,7.73,4.88,5.16,7.31,12.23,7.31,21.21v44.12h-18.19v-40.83c0-5.25-1.39-9.36-4.15-12.32-2.78-2.95-6.64-4.44-11.61-4.44-5.53,0-9.93,1.82-13.17,5.45-3.25,3.63-4.88,8.59-4.88,14.9v37.39h-17.91v-71.63h17.91v14.04h.14c4.4-10.41,12.71-15.62,24.94-15.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M500.57,130.14l-.29.29c4.78,0,9.12-.81,13.03-2.44v14.9c-5.06,1.91-11.07,2.87-18.05,2.87-8.21,0-14.54-2.34-18.98-7.02-4.43-4.68-6.66-11.03-6.66-19.05v-32.09h-13.17v-13.33l4.58-.29c6.59-.38,10.07-4.34,10.45-11.89l.58-10.17h15.33v20.63h23.78v14.9h-23.78v30.95c0,7.83,4.39,11.75,13.18,11.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M552.21,62.78c-2.64,2.34-5.91,3.51-9.82,3.51s-7.19-1.17-9.82-3.51c-2.63-2.34-3.94-5.28-3.94-8.81s1.31-6.47,3.94-8.81c2.63-2.34,5.9-3.51,9.82-3.51s7.18,1.17,9.82,3.51c2.63,2.34,3.94,5.28,3.94,8.81s-1.31,6.47-3.94,8.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M620.32,71.12h-.15c8.31,0,14.91,2.58,19.77,7.73,4.88,5.16,7.31,12.23,7.31,21.21v44.12h-18.19v-40.83c0-5.25-1.39-9.36-4.15-12.32-2.78-2.95-6.64-4.44-11.61-4.44-5.53,0-9.93,1.82-13.17,5.45-3.25,3.63-4.88,8.59-4.88,14.9v37.39h-17.91v-71.63h17.91v14.04h.14c4.4-10.41,12.71-15.62,24.94-15.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M700.26,145.61c-11.66,0-21.2-3.48-28.65-10.46-7.46-6.97-11.18-15.91-11.18-26.79s3.72-19.82,11.18-26.79c7.45-6.97,16.99-10.46,28.65-10.46s21.06,3.49,28.51,10.46c7.45,6.97,11.17,15.91,11.17,26.79s-3.72,19.82-11.17,26.79c-7.45,6.97-16.95,10.46-28.51,10.46ZM684.72,124.2c4.06,4.15,9.23,6.23,15.54,6.23s11.5-2.08,15.62-6.23c4.1-4.15,6.16-9.43,6.16-15.83s-2.06-11.68-6.16-15.83c-4.11-4.15-9.31-6.23-15.62-6.23s-11.48,2.08-15.54,6.23c-4.07,4.15-6.09,9.43-6.09,15.83s2.02,11.68,6.09,15.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1448",
    "data-name": "Raggruppa 1448"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1054",
    "data-name": "Rettangolo 1054",
    className: "cls-1",
    x: 491.72,
    y: 177.11,
    width: 8.37,
    height: 16.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1055",
    "data-name": "Rettangolo 1055",
    className: "cls-1",
    x: 533.6,
    y: 88.77,
    width: 16.75,
    height: 8.37
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1100",
    "data-name": "Tracciato 1100",
    className: "cls-1",
    d: "M558.72,185.48v-25.12h16.75v-8.37h-16.75v-55.02h-8.37v88.52h8.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1101",
    "data-name": "Tracciato 1101",
    className: "cls-1",
    d: "M516.85,185.48h8.37v8.37h8.37v-96.71h-8.37v79.96h-8.37v-8.37h-16.75v8.37h16.75v8.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1056",
    "data-name": "Rettangolo 1056",
    className: "cls-1",
    x: 617.35,
    y: 177.11,
    width: 8.37,
    height: 33.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1102",
    "data-name": "Tracciato 1102",
    className: "cls-1",
    d: "M583.85,193.86v-25.12h16.75v-8.37h-25.12v33.5h8.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1103",
    "data-name": "Tracciato 1103",
    className: "cls-1",
    d: "M600.6,168.73v25.12h8.68v-16.75h8.37v-8.37h-17.06Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1447",
    "data-name": "Raggruppa 1447"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1057",
    "data-name": "Rettangolo 1057",
    className: "cls-1",
    x: 500.1,
    y: 193.86,
    width: 8.37,
    height: 8.37
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1058",
    "data-name": "Rettangolo 1058",
    className: "cls-1",
    x: 525.22,
    y: 227.36,
    width: 8.37,
    height: 16.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1104",
    "data-name": "Tracciato 1104",
    className: "cls-1",
    d: "M533.6,252.42h75.31v-8.19h-75.31v8.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1059",
    "data-name": "Rettangolo 1059",
    className: "cls-1",
    x: 608.97,
    y: 219.04,
    width: 8.37,
    height: 16.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1060",
    "data-name": "Rettangolo 1060",
    className: "cls-1",
    x: 617.35,
    y: 210.61,
    width: 8.37,
    height: 8.44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1061",
    "data-name": "Rettangolo 1061",
    className: "cls-1",
    x: 600.47,
    y: 235.73,
    width: 8.37,
    height: 8.44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1062",
    "data-name": "Rettangolo 1062",
    className: "cls-1",
    x: 516.85,
    y: 219.04,
    width: 8.37,
    height: 8.37
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1063",
    "data-name": "Rettangolo 1063",
    className: "cls-1",
    x: 508.47,
    y: 202.23,
    width: 8.37,
    height: 16.75
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "495.91 184.27 500.1 177.11 508.47 173.95 516.85 177.11 529.41 182.44 533.6 97.15 540.14 92.96 550.35 97.15 554.53 137.13 554.53 156.28 575.47 160.36 591.07 165.92 600.6 168.73 617.34 177.11 621.53 185.48 617.34 219.04 613.16 230.38 608.85 235.73 604.66 241.39 603.69 246.44 536.24 246.44 533.6 244.23 530.51 237.72 525.22 227.36 516.85 218.98 508.47 202.23 500.1 193.86 495.91 184.27"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 491.72,
    y: 177.11,
    width: 8.37,
    height: 16.75
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "550.35 185.48 558.72 185.48 558.72 160.36 575.47 160.36 575.47 151.98 558.72 151.98 558.72 96.96 550.35 96.96 550.35 88.77 533.6 88.77 533.6 97.15 550.35 97.15 550.35 185.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "525.22 185.48 525.22 193.86 533.6 193.86 533.6 97.15 525.22 97.15 525.22 177.11 516.85 177.11 516.85 185.48 525.22 185.48"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 500.1,
    y: 168.73,
    width: 16.75,
    height: 8.37
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "617.65 177.11 617.65 168.73 600.6 168.73 600.6 193.86 609.28 193.86 609.28 177.11 617.34 177.11 617.34 210.61 617.34 219.04 625.72 219.04 625.72 210.61 625.72 177.11 617.65 177.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "583.85 193.86 583.85 168.73 600.6 168.73 600.6 160.36 575.47 160.36 575.47 193.86 583.85 193.86"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 500.1,
    y: 193.86,
    width: 8.37,
    height: 8.37
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "533.6 244.11 533.6 227.36 525.22 227.36 525.22 219.04 516.85 219.04 516.85 227.42 525.22 227.42 525.22 244.11 533.6 244.11"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 533.6,
    y: 244.23,
    width: 75.31,
    height: 8.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 608.97,
    y: 219.04,
    width: 8.37,
    height: 16.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 600.47,
    y: 235.73,
    width: 8.37,
    height: 8.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 508.47,
    y: 202.23,
    width: 8.37,
    height: 16.75
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInterattivoNew);
export default __webpack_public_path__ + "static/media/logo_interattivo_new.833488e1252ab2c9e3838fc4eb9d058c.svg";
export { ForwardRef as ReactComponent };